import type { CandidateJourney } from "./journeyTypes";

function journeyRouteSignature(path: CandidateJourney): string {
  return path.steps.map((step) => step.page.id).join(">");
}

export function uniqueJourneyRoutes(
  paths: CandidateJourney[],
): CandidateJourney[] {
  const routes = new Map<string, CandidateJourney>();
  for (const path of paths) {
    const signature = journeyRouteSignature(path);
    const current = routes.get(signature);
    if (!current || (!current.legacy && path.legacy)) {
      routes.set(signature, path);
    }
  }
  return [...routes.values()];
}
